<nav class="navbar navbar-expand-md navbar-light homehunt_nav" *ngIf="appState.companyInfo$ | async as companyInfo">
  <div class="text-center mt-3">
    <h5 class="font-italic">Coming Soon!</h5>
    <p class="hh-paragraph hh-body-heading">
      {{ companyInfo?.geoCoverageConfig?.noCoverageMessage }}
    </p>
    <p class="hh-paragraph">We would still love to connect you with a real estate professional.</p>
    <div class="form-inline my-3">
      <a [href]="companyInfo?.siteUrls?.getStarted?.link" class="mx-auto">
        <button mat-flat-button type="submit">
          {{ companyInfo?.siteUrls?.getStarted?.displayText }}
        </button>
      </a>
    </div>
  </div>
</nav>
